import React, { useRef, useState } from "react";

import {
    Dialog,
    Button,
    DialogContent,
    DialogActions,
    Divider,
    Grid,
    TextField,
    Switch,
    Select,
    MenuItem,
    Modal,
} from "@material-ui/core";

import { toast } from "react-toastify";
import { statusEnum } from "../../config/status";
import { categoryEnum } from "../../config/category";
import { gradeEnum } from "../../config/grade";
import tableIcons from "../../config/tableIcons";
import InputMask from "react-input-mask";

import List from "../../components/List";
import Label from "../../components/Label";
import Description from "../../components/Description";
import EventApi from "../../services/event";

import { ContainerBox, Align, Content, Header, LogoName } from "./styles";
import { config } from "../../config";

import html2pdf from "html2pdf.js";
import { useReactToPrint } from "react-to-print";
import html2canvas from "html2canvas";
import Loading from "../../components/Loading";
import TagEditor from "../../components/TagEditor";
import usePersonData from "../../hooks/usePersonData";
import { formatDateToTimeZoneUTC, getFirstAndLastNames } from "../../utils/Functions";
import Credential from "../../components/Credential";
import CreateGuest from "./CreateGuest";
import { eventRoles } from "../../utils/Enums";
import AssociateModal from "../../components/AssociateModal";
import { settings } from "../../config/eventSettings";

const Credentials = (props) => {
    const { updateCredential } = usePersonData();
    const [statusNames, setStatus] = useState([]);
    const [categoryNames, setCategory] = useState([]);
    const [statusValues, setStatusValues] = useState({});
    const [categoryValues, setCategoryValues] = useState({});
    const [gradeNames, setGrade] = useState([]);
    const [gradeValues, setGradeValues] = useState({});
    const [person, setPerson] = useState({});
    const [dialogOpen, setDialogOpen] = useState(false);
    const [dialogPrintOpen, setDialogPrintOpen] = useState(false);
    const [totalShowed, setTotalShowed] = useState(0);
    const [totalPeople, setTotalPeople] = useState(0);
    const [totalCredentiated, setTotalCredentiated] = useState(0);
    const [createGuestOpen, setCreateGuestOpen] = useState(false);
    const [isOpenMaterialsModal, setIsOpenMaterialsModal] = useState(false);

    const [isLoading, setIsLoading] = useState(false);

    const columns = settings.fields;

    const actions = [
        {
            icon: tableIcons.Edit,
            tooltip: "Editar convidado",
            onClick: (e, request) => {
                setPerson({ ...request, name_tag: request?.name_tag ? request?.name_tag : request?.name });
                setDialogOpen({ dialogOpen: true });
            },
        },
        {
            icon: tableIcons.Print,
            tooltip: "Imprimir",
            onClick: (e, request) => {
                setPerson({ ...request });
                setDialogPrintOpen({ dialogPrintOpen: true });
            },
        },
        // {
        //     icon: tableIcons.Add,
        //     tooltip: "Items",
        //     onClick: (e, request) => {
        //         setPerson({ ...request });
        //         setIsOpenMaterialsModal({ isOpenMaterialsModal: true });
        //     },
        // },
    ];

    const componentRef = useRef(null);

    const handleOpenCreateGuest = () => {
        setCreateGuestOpen(true);
    };
    const handleCloseCreateGuest = () => {
        setCreateGuestOpen(false);
    };
    const handleCloseModal = () => {
        setIsOpenMaterialsModal(false);
    };

    function onChange(event) {
        const { value, name } = event.target;
        setPerson({ ...person, [name]: value });
    }
    const handleChange = (event) => {
        const { checked, name } = event.target;
        setPerson({ ...person, [name]: checked });
    };
    const handleSelect = (event, valuesList, keyName1, keyName2) => {
        const { value } = event.target;
        Object.keys(valuesList).forEach((key) => {
            if (valuesList[key].name === value) {
                setPerson({
                    ...person,
                    [keyName1]: parseInt(key, 10),
                    [keyName2]: value,
                });
            }
        });
    };

    const handleSelectRole = (event) => {
        const { value } = event.target;
        setPerson({
            ...person,
            event_category: value,
        });
    };

    const handlePrintTag = () => {
        const element = componentRef.current;
        if (!element) {
            toast.error("Elemento para impressão não encontrado.");
            return;
        }

        const previousVisibility = element.style.visibility;
        element.style.visibility = "visible"; // Ensure visibility for rendering
        html2canvas(element).then((canvas) => {
            const imgData = canvas.toDataURL("image/png");
            const printableArea = window.open("", "PRINT", "height=600,width=800");
            printableArea.document.write("<html><head><title>Imprimir Credencial</title></head><body>");
            printableArea.document.write(`<img src="${imgData}" style="width:100%;height:auto;">`);
            printableArea.document.write("</body></html>");
            printableArea.document.close();
            printableArea.focus();
            printableArea.print();
            printableArea.close();
            element.style.visibility = previousVisibility; // Restore original visibility
        });
    };

    const handlePrint = useReactToPrint({
        content: () => componentRef.current,
    });
    const handleClose = () => {
        setDialogOpen(false);
    };
    const handleClosePrint = () => {
        setDialogPrintOpen(false);
    };
    const handleDownload = async () => {
        try {
            const sticker = document.getElementById("to_pdf");
            if (!person) throw new Error("Ocorreu um erro ao pegar dados do participante");
            if (!sticker) throw new Error("Ocorreu um erro ao pegar info da credencial");

            toast.info("Gerando arquivo");

            await html2pdf()
                .set({
                    margin: 2,
                    filename: `${person.name.replace(/\s/g, "_")}.pdf`,
                    image: { quality: 1 },
                    html2canvas: { scale: 2, useCORS: true },
                    pagebreak: { mode: "avoid-all" },
                    jsPDF: { format: [340, 151] },
                })
                .from(sticker)
                .save();

            toast.success("Download em execução");
        } catch (error) {
            console.log(error);
            toast.error(error);
        }
    };

    const isValidForm = () => {
        let isValid = true;
        const errors = [];
        Object.entries(person).forEach(([key, value]) => {
            if (key === "name") {
                if (value === "" || !value) {
                    isValid = false;
                    errors.push("Insira o nome completo");
                }
            }
            // if (key === "email") {
            //     if (value === "" || !value) {
            //         isValid = false;
            //         errors.push("Insira um endereço de email");
            //     }
            // }
            // if (key === "category") {
            //     if (value === "" || !value) {
            //         isValid = false;
            //         errors.push("Selecione uma categoria");
            //     }
            // }
        });
        if (errors && errors.length) errors.map((e) => toast.warn(e));
        return isValid;
    };

    const formatData = () => {
        return {
            ...person,
            certificate: person?.certificate ? 1 : 0,
            cpf: person?.cpf ? person.cpf.match(/\d/g).join("") : null,
            phone: person?.phone ? person.phone.match(/\d/g).join("") : null,
            extra_people: person?.extra_people || [],
            email: person?.email?.toLowerCase(),
            event_days_subscribed: person?.event_days_subscribed || ["*"],
            event_days_attended: person?.event_days_attended ? person?.event_days_attended : ["*"],
        };
    };

    const updatePerson = () => {
        setIsLoading(true);
        if (!isValidForm()) return;
        // EventApi.updatePerson(person.id, {
        //     ...person,
        //     certificate: person.certificate ? 1 : 0,
        //     cpf: person?.cpf ? person?.cpf?.match(/\d/g)?.join("") : null,
        //     phone: person?.phone ? person?.phone?.match(/\d/g)?.join("") : null,
        //     email: person.email.toLowerCase(),
        //     category_id: 1,
        //     grade_id: 1,
        //     event_days_attended: person?.event_days_attended ? person.event_days_attended : ["*"],
        //     event_days_subscribed: ["*"],
        // })
        const personToUpdate = formatData();
        EventApi.updatePerson(person.id, personToUpdate)
            .then((resp) => {
                if (!!resp.data) {
                    toast.success("usuário alterado com sucesso!");
                    handleClose();
                    setIsLoading(false);
                    window.location.reload();
                }
            })
            .catch(function (error) {
                setIsLoading(false);
                toast.error(error);
            });
    };

    const handleUpdateCredential = async () => {
        setIsLoading(true);
        await updateCredential(person.id, 1);
        setIsLoading(false);
    };

    const getRows = async () => {
        try {
            setIsLoading(true);

            const [respEvent, statusResp] = await Promise.all([
                EventApi.getAllPersonByEvent(1, {}),
                EventApi.getStatus(),
                // EventApi.getCategory(),
                // EventApi.getGrade(),
            ]);

            if (!respEvent || !statusResp.data) {
                throw new Error("Failed to load data");
            }

            const status = Object.fromEntries(statusResp.data.data.map((item) => [item.id, item]));
            // const category = Object.fromEntries(catResp.data.data.map((item) => [item.id, item]));
            // const grade = Object.fromEntries(gradeResp.data.data.map((item) => [item.id, item]));

            setStatus(Object.values(status).map((item) => item.name));
            setStatusValues(status);
            // setCategory(Object.values(category).map((item) => item.name));
            // setCategoryValues(category);
            // setGrade(Object.values(grade).map((item) => item.name));
            // setGradeValues(grade);

            const totalPeople = respEvent.data.data.length;
            let totalShowedUp = 0;
            let totalCredentials = 0;

            const formatedList = respEvent.data.data.map((item) => {
                const isCredenciated = item.credential_generated;
                if (item.status_id === 5) totalShowedUp++;
                if (isCredenciated) totalCredentials++;

                return {
                    ...item,
                    status: status[item.status_id]?.name || "",
                    statusName: statusEnum[status[item.status_id]?.name] || "",
                    // category: item.category_id ? category[item.category_id]?.name || "" : "",
                    // categoryName: item.category_id ? categoryEnum[category[item.category_id]?.name] || "" : "",
                    // grade: item.grade_id ? grade[item.grade_id]?.name || "" : "",
                    // gradeName: item.grade_id ? gradeEnum[grade[item.grade_id]?.name] || "" : "",
                    positionValue: item.position?.value || "",
                    isVip: item.vip ? "Sim" : "Não",
                    isCredenciated: isCredenciated ? "Sim" : "Não",
                };
            });

            setTotalPeople(totalPeople);
            setTotalShowed(totalShowedUp);
            setTotalCredentiated(totalCredentials);
            setIsLoading(false);

            return { rows: formatedList, total: respEvent.data.total };
        } catch (error) {
            console.error(error);
            toast.error(error.message || "Erro ao carregar os dados");
            setIsLoading(false);
            return { rows: [], total: 0 };
        }
    };

    const printDialog = (
        <>
            <Dialog onClose={handleClose} open={dialogPrintOpen}>
                <ContainerBox className="content">
                    <DialogContent style={{ minWidth: "400px", maxHeight: "400px" }}>
                        <Label size="medium" color="dark" align="left" weight="700" padding="5px 0">
                            Imprimir Tag para {person.name}
                        </Label>
                        <Grid container justify="space-around" spacing={2}>
                            <Grid id="teste" item md={12} style={{ width: "100%" }}>
                                <div
                                    ref={componentRef}
                                    id="to_pdf"
                                    className="card border-0"
                                    // style={{ width: "240px", height: "120px", border: "none" }}
                                    style={{ width: "340px", height: "189px", border: "none" }}
                                >
                                    <Credential
                                        id={person.id}
                                        name={person?.name_tag ? person.name_tag : getFirstAndLastNames(person.name)}
                                        company={person.company}
                                        // role={person.role}
                                        qrcode={false}
                                    />
                                </div>
                            </Grid>
                        </Grid>
                    </DialogContent>
                    <DialogActions>
                        <Button variant="contained" onClick={handleClosePrint} color="secondary">
                            cancelar
                        </Button>
                        <Button
                            variant="contained"
                            onClick={async () => {
                                await handleUpdateCredential();
                                handlePrint();
                            }}
                            color="primary"
                        >
                            Imprimir
                        </Button>
                    </DialogActions>
                </ContainerBox>
            </Dialog>
        </>
    );

    const editDialog = (
        <>
            <Dialog onClose={handleClose} open={dialogOpen}>
                <ContainerBox className="content">
                    <DialogContent>
                        <Label size="medium" color="dark" align="left" weight="700" padding="5px 0">
                            Detalhes do convidado
                        </Label>
                        <Description name="id:" value={person.id} />
                        {/* <Description name="cpf:" value={person.cpf} /> */}
                        <Divider />
                        <Grid container justify="space-around" spacing={2}>
                            <Grid item md={6}>
                                <TextField
                                    key="nome"
                                    name="name"
                                    required
                                    label="Nome do convidado"
                                    onChange={onChange}
                                    value={person.name}
                                    fullWidth
                                />
                            </Grid>
                            <Grid item md={6}>
                                <TextField
                                    key="name_tag"
                                    name="name_tag"
                                    label="Nome Etiqueta"
                                    onChange={onChange}
                                    value={person.name_tag}
                                    fullWidth
                                />
                            </Grid>
                            <Grid item md={6}>
                                <TextField
                                    key="email"
                                    name="email"
                                    label="Email para contato"
                                    onChange={onChange}
                                    value={person.email}
                                    fullWidth
                                />
                            </Grid>
                            <Grid item md={6}>
                                <TextField
                                    key="cpf"
                                    name="cpf"
                                    label="Documento"
                                    onChange={onChange}
                                    value={person.cpf}
                                    fullWidth
                                />
                            </Grid>
                        </Grid>
                        <Grid container justify="space-around" spacing={2}>
                            <Grid item md={6}>
                                <TextField
                                    key="company"
                                    name="company"
                                    label="Empresa"
                                    onChange={onChange}
                                    value={person.company}
                                    fullWidth
                                />
                            </Grid>
                            <Grid item md={6}>
                                <TextField
                                    key="role"
                                    name="role"
                                    label="Cargo"
                                    onChange={onChange}
                                    value={person.role}
                                    fullWidth
                                />
                            </Grid>
                        </Grid>
                        <Grid container justify="space-around" spacing={2}>
                            <Grid item md={6}>
                                <InputMask
                                    mask="+55 (99) 9 9999-9999"
                                    value={person.phone}
                                    onChange={onChange}
                                    disabled={false}
                                    maskChar=""
                                    type="text"
                                    name="phone"
                                >
                                    {() => (
                                        <TextField
                                            key="phone"
                                            name="phone"
                                            label="Telefone para contato"
                                            fullWidth
                                            value={person.phone}
                                            onChange={onChange}
                                        />
                                    )}
                                </InputMask>
                            </Grid>
                            {/* <Grid item md={6}>
                                <label>Status:</label>
                                <Select
                                    label="Status"
                                    name="status"
                                    fullWidth
                                    value={person.status}
                                    onChange={(e) => handleSelect(e, statusValues, "status_id", "status")}
                                >
                                    {statusNames.map((item) => {
                                        return <MenuItem value={item}>{statusEnum[item]}</MenuItem>;
                                    })}
                                </Select>
                            </Grid> */}
                            <Grid item md={12}>
                                <label>Categoria:</label>
                                <Select
                                    placeholder="Categoria"
                                    label="Categoria"
                                    name="event_category"
                                    fullWidth
                                    value={person.event_category}
                                    onChange={(e) => handleSelectRole(e)}
                                >
                                    {eventRoles.map((item) => {
                                        return <MenuItem value={item}>{item}</MenuItem>;
                                    })}
                                </Select>
                                {/* <Align>
                                    <Switch checked={person.vip} onChange={handleChange} name="vip" />
                                    <Label>vip</Label>
                                </Align>
                                <Align>
                                    <Switch checked={person.certificate} onChange={handleChange} name="certificate" />
                                    <Label>certificado</Label>
                                </Align> */}
                            </Grid>
                            <Grid id="teste" item md={12} style={{ width: "100%" }}>
                                <div
                                    ref={componentRef}
                                    id="to_pdf"
                                    className="card border-0"
                                    // style={{ width: "240px", height: "120px", border: "none" }}
                                    style={{ width: "280px", height: "110px", border: "none" }}
                                >
                                    <Credential
                                        id={person.id}
                                        name={person?.name_tag ? person.name_tag : getFirstAndLastNames(person.name)}
                                        company={person.company}
                                        // role={person.role}
                                        qrcode={false}
                                    />
                                </div>
                            </Grid>
                        </Grid>
                    </DialogContent>
                    <DialogActions>
                        {/* <Button variant='contained' onClick={handleDownload} color="default">
                            gerar pdf
                        </Button> */}
                        <Button variant="contained" onClick={handleClose} color="secondary">
                            cancelar
                        </Button>
                        <Button variant="contained" onClick={updatePerson} color="primary">
                            salvar dados
                        </Button>
                    </DialogActions>
                </ContainerBox>
            </Dialog>
        </>
    );

    const modal = (
        <Dialog fullWidth onClose={handleCloseCreateGuest} open={createGuestOpen}>
            <ContainerBox className="content">
                <CreateGuest
                    handleClose={handleCloseCreateGuest}
                    categoryNames={categoryNames}
                    categoryValues={categoryValues}
                    gradeNames={gradeNames}
                    gradeValues={gradeValues}
                />
            </ContainerBox>
        </Dialog>
    );

    return (
        <ContainerBox>
            <Header style={{ display: "flex" }}>
                <LogoName>{config.EVENT_NAME}</LogoName>
                <div>
                    <Button
                        size="nano"
                        variant="contained"
                        color="default"
                        format="solid"
                        width="100%"
                        onClick={handleOpenCreateGuest}
                    >
                        Novo Convidado
                    </Button>
                </div>
            </Header>
            {isLoading && <Loading />}
            {editDialog}
            {printDialog}
            {modal}

            <AssociateModal participant={person} onClose={handleCloseModal} open={isOpenMaterialsModal} />

            {/* <TagEditor
                dialogPrintOpen={dialogPrintOpen}
                handleClosePrint={handleClose}
                person={person}
                updateCredential={updateCredential}
            /> */}

            <div
                ref={componentRef}
                id="to_pdf"
                className="card border-0"
                style={{
                    width: "480px",
                    height: "204px",
                    border: "none",
                    visibility: "hidden",
                    position: "absolute",
                }}
            >
                <Credential
                    id={person.id}
                    name={person?.name_tag ? person.name_tag : getFirstAndLastNames(person.name)}
                    company={person.company}
                    // role={person.role}
                    qrcode={false}
                />
            </div>
            <Content>
                {/* <div>
                    {totalShowed ? (
                        <div style={{ padding: "2px" }}>
                            <h2>
                                Compareceram: {totalShowed} / {totalPeople}
                            </h2>
                        </div>
                    ) : null}
                    {totalCredentiated ? (
                        <div style={{ padding: "2px" }}>
                            <h2>Total Credenciados: {totalCredentiated}</h2>
                        </div>
                    ) : null}
                </div> */}

                <List columns={columns} rows={[]} getRows={getRows} actions={actions} />
            </Content>
        </ContainerBox>
    );
};

export default Credentials;
